import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
    scale: 0.98
  },
  in: {
    opacity: 1,
    y: 0,
    scale: 1
  },
  out: {
    opacity: 0,
    y: -20,
    scale: 1.02
  }
};

const pageTransition = {
  type: 'tween',
  ease: [0.25, 0.46, 0.45, 0.94],
  duration: 0.4
};

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const reducedMotion = useReducedMotion();
  // O primeiro carregamento já chega pronto (HTML pré-renderizado): animar da opacidade 0
  // faria a página sumir e reaparecer. A transição vale só na navegação dentro do site.
  const firstRender = useRef(true);
  useEffect(() => { firstRender.current = false; }, []);
  const animateEntrance = !reducedMotion && !firstRender.current;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={animateEntrance ? "initial" : false}
        animate="in"
        exit={reducedMotion ? undefined : "out"}
        variants={pageVariants}
        transition={animateEntrance ? pageTransition : { duration: 0 }}
        className="w-full"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
